export var addAccessLogNotice = function addAccessLogNotice() {
  var originalHandler = Oskari.getSandbox().requestHandler('AddMapLayerRequest');
  Oskari.getSandbox().requestHandler('AddMapLayerRequest', {
    handleRequest: function handleRequest(unused, request) {
      var sandbox = Oskari.getSandbox();
      var mapLayerService = sandbox.getService('Oskari.mapframework.service.MapLayerService');
      var layer = mapLayerService.findMapLayer(request.getMapLayerId());
      if (layer.getAttributes().sensitive !== true) {
        // pass through as normal
        originalHandler.handleRequest.apply(originalHandler, [unused, request]);
        return;
      }
      // notify that we are tracking usage
      showConfirm(function (accepted) {
        if (accepted) {
          originalHandler.handleRequest.apply(originalHandler, [unused, request]);
        } else {
          // trigger update on layerlist (so layer that is not added is not shown as added)
          var evt = Oskari.eventBuilder('AfterMapLayerRemoveEvent')(layer);
          sandbox.notifyAll(evt);
        }
      });
    }
  });
  var showConfirm = function showConfirm(done) {
    var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
    dialog.makeModal();
    var cancelBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.CancelButton');
    var okBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.OkButton');
    cancelBtn.setHandler(function () {
      dialog.close();
      done(false);
    });
    okBtn.setHandler(function () {
      dialog.close();
      done(true);
    });
    var title = Oskari.getMsg('AccessLog', 'title');
    var content = Oskari.getMsg('AccessLog', 'warning');
    dialog.show(title, content, [cancelBtn, okBtn]);
  };
};